import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AbstractWalletProvider } from "@abstract-foundation/agw-react"
import { WagmiProvider } from 'wagmi'
import { wagmiConfig } from './core/configs.ts'
import { RainbowKitProvider } from "@rainbow-me/rainbowkit"

import App from './App.tsx'
import { ToastProvider } from './core/contexts/ToastContext.tsx'

import "@rainbow-me/rainbowkit/styles.css"
import './index.css'
import { AbsSessionProvider } from './core/contexts/AbsSessionContext.tsx'
import { ErrorProvider } from './core/contexts/ErrorContext.tsx'
import { ABS_CHAIN } from './core/constants.ts'
import { BrowserRouter } from 'react-router-dom'
import { ModalProvider } from './core/contexts/ModalContext.tsx'
import { AddFundsProvider } from './core/providers/AddFundsProvider.tsx'

const queryClient = new QueryClient()
createRoot(document.getElementById('root')!).render(
  <>
      <BrowserRouter>
        <AbstractWalletProvider chain={ABS_CHAIN}>
          <WagmiProvider config={wagmiConfig}>
              <QueryClientProvider client={queryClient}>
                <RainbowKitProvider>
                  <AbsSessionProvider>
                    <ToastProvider>
                      <ErrorProvider>
                        <ModalProvider>
                          <App />
                        </ModalProvider>
                      </ErrorProvider>
                    </ToastProvider>
                  </AbsSessionProvider>
                </RainbowKitProvider>
              </QueryClientProvider>
          </WagmiProvider>
        </AbstractWalletProvider>
      </BrowserRouter>

    <AddFundsProvider />
  </>
)